/**
 * @author HungNS
 */
import $ from 'jquery';
/* eslint-disable */
let settings, tester;
$.fn.passwordStrength = function (option) {
    const ele = $(this);
    settings = $.extend($.tester.defaultSettings, option);
    tester = new $.tester(ele, settings);
    return tester;
};

$.fn.dismiss = function (option) {
    const {element} = option;
    if (option.isVuejs !== undefined && option.isVuejs) {
        const eleName = $(element).attr('data-id');
        $('#' + eleName + '_div').remove();
    } else {
        $(".password-progressDiv").remove();
    }
};

$.fn.hidePasswordStrength = function (option) {
    $(".password-progressDiv").hide();
};

$.fn.showPasswordStrength = function (option) {
    $(".password-progressDiv").show();
};

$.tester = function (ele, settings) {
    this.init(ele, settings);
};

$.extend($.tester, {
    defaultRules: {
        lowercase: {
            rule: /[a-z]+/, // at least one lower case letter
            score: 1,
            method: true
        },
        uppercase: {
            rule: /[A-Z]+/, // at least one UPPER case letter
            score: 5,
            method: true
        },
        number: {
            rule: /\d+/,// at least one number
            score: 5,
            method: true
        },
        number3: {
            rule: /(.*[0-9].*[0-9].*[0-9])/,// at least 3 number
            score: 5,
            method: true
        },
        speChar: {
            rule: /[~!@#$%^&*()_\-+=|{}\[\]'":;?\/<>.,]/,
            score: 5,
            method: true
        },
        speChar2: {
            rule: /(.*[~!@#$%^&*()_\-+=|{}\[\]'":;?\/<>.,].*[~!@#$%^&*()_\-+=|{}\[\]'":;?\/<>.,])/,
            score: 5,
            method: true
        },
        loweruppercase: {
            rule: /([a-z].*[A-Z])|([A-Z].*[a-z])/, // upper and lower case
            score: 2,
            method: true
        },
        lettersnumber: {
            rule: /([a-zA-Z])|([0-9])/, // letters and numbers
            score: 2,
            method: true
        },
        loweruppercase2: {
            rule: /([a-z].*[~!@#$%^&*()_\-+=|{}\[\]'":;?\/<>.,]-)|([~!@#$%^&*()_\-+=|{}\[\]'":;?\/<>.,].*[0-9].*[A-Z])/,
            score: 2,
            method: true
        }
    },
    defaultSettings: {
        gradeClass: {
            bad: 'bg-red',
            good: 'bg-blue',
            strong: 'bg-green'
        }
    },
    prototype: {
        init: function (ele, settings) {
            let eleName;
            if (settings.isVuejs != undefined && settings.isVuejs) {
                eleName = ele.attr('data-id');
            } else {
                eleName = ele.attr('name');
            }
            const rules = $.tester.defaultRules;
            const progress = '<div class="password-progressDiv" id="' + eleName + '_div"><div class="password-progress"><div data-name="' + eleName + '" class="progress-bar" style="width: 0%;"><span id="' + eleName + '_tx" style="text-align: center;color:white;font-weight: bold;"></span></div></div><div style="text-align: right"></div></div>';
            let $progress;
            if ($('.progress-bar[data-name="' + eleName + '"]').length < 1) {
                ele.after(progress);
            }
            $progress = $('.progress-bar[data-name="' + eleName + '"]');
            if (settings.isVuejs != undefined && settings.isVuejs) {
                $.tester.checkStrength(settings.value, rules, $progress, eleName);
            } else {
                ele.on('input.passwordStrength', function () {
                    $.tester.checkStrength($(this).val(), rules, $progress, eleName);
                });
            }
        },

    },
    addRules: function (rules) {
        $.extend($.tester.defaultRules, rules);
    },

    checkStrength: function (val, rules, $progress, elementName) {
        let strength = 0,
            score,
            per,
            colorClass,
            i,
            rule,
            method,
            tx;
        for (i in rules) {
            rule = rules[i].rule;
            method = rules[i].method;
            score = rules[i].score;
            if (val.match(rule)) {
                strength += (method === true) ? score : (method === false) ? -1 : 0;
            }
        }
        if (val.length >= 1 && val.length <= 4) {
            strength += 3;
        } else if (val.length >= 5 && val.length <= 7) {
            strength += 6;
        } else if (val.length >= 8 && val.length <= 10) {
            strength += 12;
        } else if (val.length >= 11 && val.length <= 15) {
            strength += 20;
        } else if (val.length >= 16 && val.length <= 20) {
            strength += 26;
        } else if (val.length >= 21 && val.length <= 25) {
            strength += 32;
        } else if (val.length >= 26 && val.length <= 30) {
            strength += 38;
        } else if (val.length >= 31 && val.length <= 35) {
            strength += 44;
        } else if (val.length >= 36) {
            strength += 50;
        }

        // per = strength / 50 * 100;
        colorClass = (strength <= 44) ? settings.gradeClass.bad : (strength >= 45 && strength <= 55) ? settings.gradeClass.good : settings.gradeClass.strong;
        tx = (strength <= 44) ? '弱い' : (strength >= 45 && strength <= 55) ? '良い' : '強い';
        if (strength == 0) {
            per = 0;
        } else if (strength <= 44) {
            per = 100 / 3;
        } else if (strength >= 45 && strength <= 55) {
            per = 200 / 3;
        } else {
            per = 100;
        }
        $progress.css('width', per + '%');
        $progress.attr('class', 'progress-bar ' + colorClass);
        $('#' + elementName + '_tx').text(tx);
    }
});
